import { standardFontIds } from './constants'
import { Descendant, EditorDraft, FontId } from './types'

export const isStandardFont = (fontId: FontId) => standardFontIds.includes(fontId)
export const isVersion2Draft = (draft: Descendant[] | EditorDraft): draft is EditorDraft =>
  !Array.isArray(draft)
